import React from 'react';
import PropTypes from 'prop-types';
import { Chip, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { isValidEmail } from './helpers';

/** To/CC çip alanı: Enter, virgül veya odak kaybında ekler; geçersiz adres kırmızı çip olur. */
const RecipientField = ({ label, value, onChange, disabled }) => (
  <Autocomplete
    multiple
    freeSolo
    autoSelect
    size="small"
    options={[]}
    value={value}
    disabled={disabled}
    onChange={(e, next) => {
      const parts = [];
      next.forEach(v =>
        String(v)
          .split(/[,;\s]+/)
          .forEach(p => p && parts.push(p.trim()))
      );
      onChange(parts.filter((a, i) => parts.findIndex(b => b.toLowerCase() === a.toLowerCase()) === i));
    }}
    getOptionLabel={o => String(o)}
    renderTags={(tags, getTagProps) =>
      tags.map((tag, index) => (
        <Chip
          size="small"
          label={tag}
          style={isValidEmail(tag) ? undefined : { backgroundColor: '#ffcdd2' }}
          {...getTagProps({ index })}
        />
      ))
    }
    renderInput={params => <TextField {...params} variant="outlined" label={label} />}
  />
);

RecipientField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default RecipientField;
